import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { memo } from 'react';
import isEqual from 'react-fast-compare';

import ItemShelf from '@/components/ItemShelf/ItemShelf';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaries } from '@/redux/modules/item/summary/itemSummary.selectors';
import { orderByCatalogSaleStartAscending } from '@/redux/modules/sorting';
import { getHasLoadedUpcomingIds, getUpcomingItemIds } from '@/redux/modules/upcoming/items/upcomingItems.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';

type Props = {
    className?: string;
    testid?: string;
};

const ComingUpCarousel = ({ className, testid }: Props) => {
    const { formatMessage } = useIntl();
    const upcomingItemIds = useAppSelector(getUpcomingItemIds);
    const items = useAppSelector((state) => getItemSummaries(state, upcomingItemIds), isEqual);
    const sortedItems = (orderByCatalogSaleStartAscending(items) || []) as ItemSummary[];
    const itemIds = sortedItems.slice(0, 12).map(({ itemId }) => itemId);
    const upcomingItemsLoaded = useAppSelector(getHasLoadedUpcomingIds);

    if (!itemIds.length && upcomingItemsLoaded) {
        return null;
    }

    return (
        <ItemShelf
            allowBidding
            className={className}
            data-testid={testid}
            identifier="comingUp"
            itemIds={itemIds}
            showBidStatus
            showPagination={false}
            title={formatMessage({ id: 'coming_up_title' })}
        />
    );
};

export default memo<Props>(ComingUpCarousel);
